/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Side of trade, buying, or selling the base currency
 */
export type GetConversionQuoteBodySide = typeof GetConversionQuoteBodySide[keyof typeof GetConversionQuoteBodySide];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetConversionQuoteBodySide = {
  buy: 'buy',
  sell: 'sell',
} as const;
